<div class="social-share" on:click={toggleSharePanel}>
  <img src={shareLogo} alt="share logo" />
  <span>Share</span>
</div>
{#if showSharingPanel}
<div class="social-share-panel" transition:fade="{{delay: 250, duration: 300, easing: quintOut}}">
  <div class="social-share-panel-wrapper">
      <div class="close-cta" on:click={toggleSharePanel}>
        <div class="plus-sign"></div>
      </div>
      <ul>
        {#each options as {title, image, url}}
          <li on:click={() => { shareLink(title) }}>
            <a href={url} target="_blank" rel="noopener noreferrer">
                <img src={image} alt={title} />
            </a>
          </li>
        {/each}
      </ul>
      <div class="url-link-copy-wrapper">          
        <span class="url-link" bind:this={urlLinkElement}>
          {shareUrl}
        </span>
        <a href="javascript:void(0)" class="button" on:click={copyLink} bind:this={copyButtonElement}>COPY</a>
      </div>
  </div>
</div>
{/if}



<script>
import tippy from "tippy.js";
//@ts-ignore
import ShareLogo from "../../assets/images/share_logo.svg";
//@ts-ignore
import Whatsapp from "../../assets/images/Whatsapp.svg";
//@ts-ignore
import LinkedIn from "../../assets/images/LinkedIn.svg";
//@ts-ignore
import FB from "../../assets/images/FB.svg";
//@ts-ignore
import Twitter from "../../assets/images/Twitter.svg";
//@ts-ignore
import Email from "../../assets/images/Email.svg";
import store from "../../state";
import utils from "../../utils";
import { quintOut } from "svelte/easing";
quintOut;
import { fade } from "svelte/transition";
fade;
import { afterUpdate, onDestroy } from "svelte/internal";
let shareLogo = ShareLogo;
let options = [
    {
        title: "Whatsapp",
        image: Whatsapp
    },
    {
        title: "Email",
        image: Email
    },
    {
        title: "Twitter",
        image: Twitter
    },
    {
        title: "Facebook",
        image: FB
    },
    {
        title: "LinkedIn",
        image: LinkedIn
    }
];
let shareUrl = "";
let urlLinkElement;
let showSharingPanel = false;
let currentSuburb = "";
let currentFloodLikelihood = "";
let currentState = "";
let tippyInstance;
let copyButtonElement;
store.subscribe(state => {
    if (state.selectedLocation &&
        state.selectedLocation.attributes.Suburb !== currentSuburb) {
        currentSuburb = state.selectedLocation.attributes.Suburb;
    }
    if (state.selectedLikelihood &&
        state.selectedLikelihood.value !== currentFloodLikelihood) {
        currentFloodLikelihood = state.selectedLikelihood.value;
    }
    currentState = state.currentState;
});
afterUpdate(() => {
    if (tippyInstance && tippyInstance.destroy) {
        tippyInstance.destroy();
    }
    tippyInstance = tippy(copyButtonElement, {
        size: "small",
        placement: "top",
        content: "Copied",
        trigger: "manual"
    });
});
onDestroy(() => {
    if (tippyInstance && tippyInstance.destroy) {
        tippyInstance.destroy();
    }
});
const shareLink = (platform) => {
    // const base = `${window.
    //   location.origin}${window.location.pathname}`;
    const base = `${window.location.href}`;
    let query = `as=${currentState}`;
    if (currentFloodLikelihood !== "") {
        query =
            query +
                `&flkhd=${encodeURIComponent(utils.camelCase(currentFloodLikelihood))}`;
    }
    if (currentSuburb !== "") {
        query = query + `&sb=${encodeURIComponent(currentSuburb)}`;
    }
    const constructUrl = (baseUrl, queryStr, encodeQuery) => {
        return encodeQuery
            ? `${baseUrl}?${encodeURIComponent(queryStr)}`
            : `${baseUrl}?${queryStr}`;
    };
    switch (platform) {
        case "Whatsapp":
            return `https://api.whatsapp.com/send?text=${constructUrl(base, query, true)}`;
        case "Email":
            return `mailto:?body=${constructUrl(base, query, true)}&subject=See how my suburb is affected by flooding`;
        case "Twitter":
            return `https://twitter.com/intent/tweet?url=${constructUrl(base, query, true)}`;
        case "Facebook":
            return `https://www.facebook.com/sharer.php?u=${constructUrl(base, query, true)}&t=Hello`;
        case "LinkedIn":
            return `https://www.linkedin.com/shareArticle?url=${constructUrl(base, query, true)}`;
        default:
            return `${constructUrl(base, query)}`;
    }
};
const toggleSharePanel = () => {
    if (!showSharingPanel) {
        options = options.map(item => {
            return Object.assign(Object.assign({}, item), { url: shareLink(item.title) });
        });
        shareUrl = shareLink();
    }
    showSharingPanel = !showSharingPanel;
};
const copyLink = () => {
    var _a, _b;
    let range = document.createRange();
    range.selectNode(urlLinkElement);
    tippyInstance.hide();
    (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
    (_b = window.getSelection()) === null || _b === void 0 ? void 0 : _b.addRange(range);
    document.execCommand("copy");
    tippyInstance.show();
    setTimeout(() => {
        tippyInstance.hide();
    }, 1000);
};
</script>


<style>.social-share{height:20px;width:59px;border-radius:4px;background-color:#fff;border:1px solid hsla(0,0%,50.2%,.2);box-shadow:0 1px 2px 0 rgba(0,0,0,.2);position:absolute;top:15px;right:18px;z-index:3;text-align:center;display:flex;justify-content:center;align-items:center;cursor:pointer}.social-share img{height:12px;width:auto;max-width:none;margin-right:4px}.social-share span{font-size:11px;line-height:15px;font-family:AvenirLT-Black;color:rgba(54,54,54,.8)}.social-share-panel{position:absolute;top:43px;z-index:6;right:15px}.social-share-panel-wrapper{height:156px;width:100%;max-width:377px;border-radius:4px;background-color:#fff;border:1px solid #ccc;box-shadow:0 3px 4px 0 rgba(0,0,0,.1);padding:20px 17.5px;position:relative}.social-share-panel-wrapper:after,.social-share-panel-wrapper:before{content:"";width:0;height:0;border-style:solid;border-width:0 7px 7px;position:absolute;right:20px}.social-share-panel-wrapper:before{border-color:transparent transparent #ccc;bottom:100%}.social-share-panel-wrapper:after{border-color:transparent transparent #fff;bottom:calc(100% - 1px)}.social-share-panel-wrapper .close-cta{position:absolute;right:14px;top:12px;width:30px;height:30px;display:flex;justify-content:flex-end}.social-share-panel-wrapper .close-cta .plus-sign{transform:rotate(45deg)}.social-share-panel-wrapper .close-cta .plus-sign:after,.social-share-panel-wrapper .close-cta .plus-sign:before{background-color:#c8c8c8}.social-share-panel-wrapper ul{display:flex;margin-bottom:20px;margin-top:18px;justify-content:space-between;overflow-x:auto}.social-share-panel-wrapper ul li{flex:0 0 50px;height:50px;width:50px;background-color:#fff;border:1px solid hsla(0,0%,80%,.25);box-shadow:inset 0 1px 3px 0 rgba(0,0,0,.2),0 1px 3px 0 rgba(0,0,0,.1);margin:5px 9px;border-radius:25px;display:flex;justify-content:center;align-items:center;cursor:pointer}.social-share-panel-wrapper ul li:first-of-type{margin-left:0}.social-share-panel-wrapper ul li:last-of-type{margin-right:0}.social-share-panel-wrapper ul li a{display:flex;width:25px;height:25px}.social-share-panel-wrapper ul li a img{width:25px;height:auto}.social-share-panel-wrapper .url-link-copy-wrapper{display:flex;align-items:flex-end}.social-share-panel-wrapper .url-link-copy-wrapper .url-link{height:14px;color:#1d3b78;font-size:10.5px;line-height:14px;box-shadow:none;outline:none;border:none;border-bottom:1px solid hsla(0,0%,80%,.5);border-radius:0;font-family:AvenirLT-Medium;width:100%;overflow:hidden;white-space:nowrap}.social-share-panel-wrapper .url-link-copy-wrapper .button{height:16px;min-width:33px;color:#f08403;font-size:12px;line-height:16px;text-align:center;border:none;box-shadow:none;outline:none;margin-left:12.5px}@media screen and (max-width:767px){.social-share{top:10px;height:30px}.social-share-panel{padding-left:11px;padding-right:7px;top:48px;right:0;max-width:100%}.social-share-panel-wrapper{max-width:unset}.social-share-panel-wrapper:after,.social-share-panel-wrapper:before{right:34px}}</style>
